<template lang="html">
    <Layout>
        <HeadBar></HeadBar>
        <Layout class="ivu-layout-has-sider">
            <NavigationBar active="0"></NavigationBar>
            <Layout class="content-wrap">
                <Content class="content">
                    <div class="welcome">
                        <img src="/img/logo.png">
                        <h1>欢迎登录运营控制台</h1>
                    </div>
                </Content>
            </Layout>
        </Layout>
    </Layout>
</template>

<script>
import request from 'utils/request';
import constants from 'utils/constants';
// import util from 'utils/util';
import NavigationBar from '../../components/NavigationBar';
import HeadBar from '../../components/HeadBar';
// import HeadBreadcrumb from '../../components/HeadBreadcrumb';

export default {
    name: 'index',
    components: {
        NavigationBar,
        HeadBar,
        // HeadBreadcrumb
    },
    data() {
        return {
            
        };
    },
    mounted() {
        let self = this;
        document.title = "控制台首页";

        self.init();

    },
    methods: {
        init(){
            // let self = this;
            request
                .get(constants.apiHost + "/user/isauth")
                // .catch(function (error) {
                //     self.$Message.error(
                //         error.message ? error.message : "服务异常，请稍候再试。"
                //     );
                // });
        }
    }
}

</script>

